import { NG_VALIDATORS, UntypedFormControl, Validator } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[appWhitespaceValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: WhitespaceValidatorDirective, multi: true }],
})
// todo: check why do we need it
export class WhitespaceValidatorDirective implements Validator {
    @Input() needToCheck;

    validate(field: UntypedFormControl) {
        if (!this.needToCheck) {
            return null;
        }

        if (!(field.value && field.value.trim())) {
            return {
                requiredValue: {
                    invalid: true,
                },
            };
        } else {
            return null;
        }
    }
}
